<template>
  <v-layout>
    <v-flex v-if="reportsPending">
      <v-flex>
        Getting Comm log...
        <v-progress-linear indeterminate></v-progress-linear>
      </v-flex>
    </v-flex>
    <v-flex v-else>
      <v-layout column full-width>
        <v-layout row>
          <v-flex>
            <v-autocomplete
              label="Employee"
              :items="selectableEmployees"
              item-text="name"
              item-value="id"
              v-model="selectedEmployeeID"
              :loading="employeeApiCallPending"
              :disabled="employeeApiCallPending"
              clearable
            ></v-autocomplete>
          </v-flex>

          <v-flex>
            <v-select v-model="selectedMessageType" :items="messageTypes" label="Message Type" />
          </v-flex>
        </v-layout>

        <v-flex grow>

              <v-data-table
                :items="filteredComms"
                :headers="headers"
                item-key="worksite_id"
                class="elevation-1"
                :defaultSort="{
                  sortBy: '',
                  ascending: true,
                  rowsPerPage: 100,
                }"
              >
                <template slot="items" slot-scope="{ item }">
                  <tr>
                    <td>
                      {{ item.created_at | moment('dddd, MMMM DD YYYY') }}
                    </td>
                    <td>
                      <span v-if="item.type === 'SentMessage'">
                        Sent Message
                      </span>
                      <span v-if="item.type === 'ReceivedMessage'">
                        Received Message
                      </span>
                      <span v-if="item.type === 'InternalNote'">
                        Internal Note
                      </span>
                      <span v-if="item.type === 'ShiftReview'">
                        Shift Review
                      </span>
                      <span v-if="item.type === 'UserShiftNote'">
                        SAR
                      </span>
                    </td>
                    <td>
                      <div v-if="item.type === 'SentMessage'">
                        To: 
                        {{ item.associated_to_show.first_name }}
                        {{ item.associated_to_show.last_name }}
                      </div>

                      <div v-if="item.type === 'ReceivedMessage'">
                        <span v-if="item.associated_to_show.last_name">
                          From: 
                          {{ item.associated_to_show.first_name }}
                          {{ item.associated_to_show.last_name }}
                        </span>
                        <span v-else>
                          From: VSS Bot
                        </span>
                      </div>

                      <div v-if="item.type === 'InternalNote'">
                        From: {{ item.associated_to_show.id }}
                        {{ item.associated_to_show.first_name }}
                        {{ item.associated_to_show.last_name }}
                      </div>

                      <div v-if="item.type === 'ShiftReview'">
                        <span class="mr-2">
                          <router-link :to="{ name: 'shiftDetail', params: { shiftId: item.object.shift_id } }" target="_blank">Shift {{ item.object.shift_id }}</router-link>, 
                        </span>
                        <span>
                        Author: 
                        <router-link :to="{ name: 'clientDetail', params: { clientId: item.associated_to_show.id } }" target="_blank">{{ item.associated_to_show.first_name }} {{ item.associated_to_show.last_name }}</router-link>
                        </span>
                      </div>

                      <div v-if="item.type === 'UserShiftNote'">
                        <router-link :to="{ name: 'shiftDetail', params: { shiftId: item.associated_to_show.id } }" target="_blank">Shift {{ item.associated_to_show.id }}</router-link>
                      </div>
                    </td>
                    <td>
                      <div v-if="item.type === 'SentMessage'">
                        <v-expansion-panel>
                          <v-expansion-panel-content>
                            <template v-slot:header>
                              {{ item.object.subject }}
                            </template>
                            <v-card>
                              <v-card-text>
                                {{ item.object.message }}
                              </v-card-text>
                            </v-card>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </div>

                      <div v-if="item.type === 'ReceivedMessage'">
                        <v-expansion-panel>
                          <v-expansion-panel-content>
                            <template v-slot:header>
                              {{ item.object.subject }}
                            </template>
                            <v-card>
                              <v-card-text>
                                {{ item.object.message }}
                              </v-card-text>
                            </v-card>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </div>

                      <div v-if="item.type === 'InternalNote'">
                        {{ item.object.text }}
                      </div>

                      <div v-if="item.type === 'ShiftReview'">
                        <v-expansion-panel>
                          <v-expansion-panel-content>
                            <template v-slot:header>
                              <v-rating
                                half-increments
                                v-if="item.object.rating"
                                v-model="item.object.rating"
                                readonly
                                length="4"
                              />
                            </template>
                            <v-card>
                              <v-card-text>
                                {{ item.object.review }}
                              </v-card-text>
                            </v-card>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </div>

                      <div v-if="item.type === 'UserShiftNote'">
                        {{ item.object.note }}
                      </div>
                    </td>
                  </tr>
                </template>
              </v-data-table>
        </v-flex>

      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
  import {mapState, mapGetters} from 'vuex';
  import reportApi from '@/api/reports'
  import collectionApi from '@/api/collections'

  export default {
    computed: {
      ...mapState('userAuth', ['user']),

      filteredComms() {
        if (this.selectedMessageType === 'All') {
          return this.report
        } else {
          return this.report.filter((m) => m.type === this.selectedMessageType)
        }
      },

      //computedOffset: function () {
      //  return this.limit * (this.page - 1)
      //},
      //pageLength: function () {
      //  return Math.ceil(this.queryTotal / this.limit)
      //},
      formattedQuery: function() {
        return {
          employeeID: this.selectedEmployeeID,
          //limit: this.limit,
          //offset: this.computedOffset,
          //page: this.page,
        };
      },
    },
    created() {
      this.setUp();
    },
    watch: {
      selectedEmployeeID(val) {
        if (val) {
          this.$router.push({ query: { employeeID: parseInt(val) } })
          this.getReports()
        }
      },
    },

    data: function() {
      return {
        selectableEmployees: [],
        selectedEmployeeID: null,
        employeeApiCallPending: false,
        selectedMessageType: 'All',
        messageTypes: [
          {
            text: 'All',
            value: 'All'
          },
          {
            text: 'Sent Message',
            value: 'SentMessage'
          },
          {
            text: 'Received Message',
            value: 'ReceivedMessage'
          },
          {
            text: 'Internal Note',
            value: 'InternalNote'
          },
          {
            text: 'Shift Review',
            value: 'ShiftReview'
          },
          {
            text: 'SAR',
            value: 'UserShiftNote'
          },
        ],

        limit: 40,
        page: 1,

        reportsPending: true,
        report: {},
        //defaultSort: {
        //  sortBy: 'order',
        //  rowsPerPage: -1, //all
        //},
        headers: [
          { text: 'Date', value: 'created_at', sortable: true },
          { text: 'Type', value: 'type', sortable: true },
          { text: 'Associated Records', sortable: false, },
          { text: '', sortable: false, },
        ],
      };
    },

    methods: {
      setUp: function() {
        if (this.$route.query && this.$route.query.employeeID) {
          this.selectedEmployeeID = parseInt(this.$route.query.employeeID)
        }
        this.getEmployees();
        this.getReports();
      },

      getEmployees() {
        this.employeeApiCallPending = true
        collectionApi.getEmployees(employees => {
          this.selectableEmployees = employees
          this.employeeApiCallPending = false
        })
      },

      getReports: function() {
        this.reportsPending = true;

        reportApi.getCommLogReport(
          this.formattedQuery,
          (r) => {
            this.report = r.report
            this.reportsPending = false
          },
          err => {
            console.log(err)
            this.reportsPending = false
          }
        )
      },
    },
  };
</script>
